import RejectIcon from 'components/icons/DriveTableIcon/Reject'
import ShortlistIcon from 'components/icons/DriveTableIcon/Shortlist'
import React from 'react'

import HoldBlackIcon from '../../../../components/icons/DriveTableIcon/HoldBlack'
import ResumeDownload from '../../../../components/icons/DriveTableIcon/ResumeDownload'
import { EmptyDivElement } from '../../../../components/UIComponents/CommonStyledComponent'
import { IconContainer, IconText } from '../../style'
import { StyledDivider } from './Style'

function TableStatusIcon({
  status,
  stage,
  onChange,
  round,
  candidateStatus,
  selectedCandidateId,
  handleDownload,
}) {
  return (
    <IconContainer>
      <IconText>Select status</IconText>

      {/* Shortlist Icon */}
      {status !== 'ACCEPTED' && status !== 'SHORTLISTED' && (
        <EmptyDivElement
          onClick={() =>
            ['TO_BE_SCHEDULED', 'TO_BE_UPDATED', 'SHORTLISTED']?.some(value =>
              candidateStatus?.includes(value)
            ) || selectedCandidateId?.length === 0
              ? ''
              : onChange('SHORTLISTED')
          }
          style={{
            cursor:
              ['TO_BE_SCHEDULED', 'TO_BE_UPDATED', 'SHORTLISTED']?.some(value =>
                candidateStatus?.includes(value)
              ) || selectedCandidateId?.length === 0
                ? 'not-allowed'
                : 'pointer',
            opacity:
              ['TO_BE_SCHEDULED', 'TO_BE_UPDATED', 'SHORTLISTED']?.some(value =>
                candidateStatus?.includes(value)
              ) || selectedCandidateId?.length === 0
                ? '0.5'
                : '',
          }}
        >
          <ShortlistIcon />
        </EmptyDivElement>
      )}

      {/* Reject Icon */}
      {status !== 'REJECTED' && (
        <EmptyDivElement
          onClick={() =>
            ['TO_BE_SCHEDULED', 'REJECTED', 'TO_BE_UPDATED']?.some(value =>
              candidateStatus?.includes(value)
            ) || selectedCandidateId?.length === 0
              ? ''
              : onChange('REJECTED')
          }
          style={{
            cursor:
              ['TO_BE_SCHEDULED', 'REJECTED', 'TO_BE_UPDATED']?.some(value =>
                candidateStatus?.includes(value)
              ) || selectedCandidateId?.length === 0
                ? 'not-allowed'
                : 'pointer',
            opacity:
              ['REJECTED', 'TO_BE_UPDATED', 'TO_BE_SCHEDULED']?.some(value =>
                candidateStatus?.includes(value)
              ) || selectedCandidateId?.length === 0
                ? '0.5'
                : '',
          }}
        >
          <RejectIcon />
        </EmptyDivElement>
      )}

      {/* Hold Icon */}
      {status !== 'ABSENT' && (
        <EmptyDivElement
          onClick={() =>
            ['TO_BE_SCHEDULED', 'ABSENT', 'TO_BE_UPDATED']?.some(value =>
              candidateStatus?.includes(value)
            ) || selectedCandidateId?.length === 0
              ? ''
              : onChange('ABSENT')
          }
          style={{
            cursor:
              [
                'SHORTLISTED',
                'TO_BE_SCHEDULED',
                'ABSENT',
                'TO_BE_UPDATED',
              ]?.some(value => candidateStatus?.includes(value)) ||
              selectedCandidateId?.length === 0
                ? 'not-allowed'
                : 'pointer',
            opacity:
              [
                'SHORTLISTED',
                'ABSENT',
                'TO_BE_UPDATED',
                'TO_BE_SCHEDULED',
              ]?.some(value => candidateStatus?.includes(value)) ||
              selectedCandidateId?.length === 0
                ? '0.5'
                : '',
          }}
        >
          <HoldBlackIcon />
        </EmptyDivElement>
      )}
      <StyledDivider type="vertical" />
      <EmptyDivElement
        onClick={() => {
          if(selectedCandidateId?.length > 0)handleDownload()}
        }
        style={{
          cursor:
            [
              'SHORTLISTED',
              'TO_BE_SCHEDULED',
              'TO_BE_UPDATED',
            ]?.some(value => candidateStatus?.includes(value)) ||
            selectedCandidateId?.length === 0
              ? 'not-allowed'
              : 'pointer',
          opacity:
            ['SHORTLISTED', 'TO_BE_UPDATED', 'TO_BE_SCHEDULED']?.some(value =>
              candidateStatus?.includes(value)
            ) || selectedCandidateId?.length === 0
              ? '0.5'
              : '',
        }}
      >
        <ResumeDownload />
      </EmptyDivElement>
    </IconContainer>
  )
}

export default TableStatusIcon
